import React from 'react'
import styled from 'styled-components'
import moment from 'moment'

import { FONTS } from '../../../../../../constants'
import { formatNumber } from '../../../../../../function/math.js'
import { getPayingAvailable } from '../../../../../../function/paying'

export const PayoutDetail = ({ data = {}, detailState = {} }) => {
  const {
    project_code,
    project_name,
    lob_name,
    cost,
    delivery_date,
    credit_term,
  } = data

  const { partials = [] } = detailState
  const payingAvailable = getPayingAvailable(partials, cost)

  return (
    <React.Fragment>
      <FlexRow>
        <FlexCol flex={ 1 }>
          <Title>Project Code</Title>
          <AlignCenterWrapper>
            <Text>{ project_code }</Text>
          </AlignCenterWrapper>
        </FlexCol>
        <FlexCol flex={ 3 } margin='0 12px'>
          <Title>Description</Title>
          <AlignCenterWrapper>{ project_name }</AlignCenterWrapper>
        </FlexCol>
        <FlexCol flex={ 1 }>
          <Title>LOB</Title>
          <AlignCenterWrapper>{ lob_name }</AlignCenterWrapper>
        </FlexCol>
      </FlexRow>
      <FlexRow>
        <FlexCol flex={ 2 }>
          <CostRow>
            <FlexEndCol>
              <Title>Total Cost</Title>
              <AlignCenterWrapper>
                <Number>฿​ { formatNumber(cost) }</Number>
              </AlignCenterWrapper>
            </FlexEndCol>
            <FlexEndCol>
              <Title>Available</Title>
              <AlignCenterWrapper>
                {/* for Int use toNumber(payingAvailable) */}
                <Number color='#27AE60'>฿{ payingAvailable }</Number>
              </AlignCenterWrapper>
            </FlexEndCol>
          </CostRow>
        </FlexCol>
        <FlexCol flex={ 1 } margin='0 12px'>
          <Title>Delivery Date</Title>
          <Text>{ delivery_date ? moment(delivery_date).format('DD/MM/YYYY') : '-' }</Text>
        </FlexCol>
        <FlexCol flex={ 1 }>
          <Title>Credit Term</Title>
          <Text>{ credit_term } Days</Text>
        </FlexCol>
        <FlexCol flex={ 1 } margin='0 12px'>
          <Title>Due Date</Title>
          <Text>
            { delivery_date ? moment(delivery_date).add(credit_term, 'days').format('DD/MM/YYYY') : '-' }
          </Text>
        </FlexCol>
      </FlexRow>
    </React.Fragment>
  )
}

const Row = styled.div`
  display: flex;
`

const CostRow = styled(Row)`
  justify-content: space-between;
`

const FlexRow = styled(Row)`
  margin-bottom: 12px;
  ${p => p.flex && `flex: ${p.flex}`}
`

const Col = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
`

const FlexCol = styled(Col)`
  margin: ${p => p.margin};
  ${p => p.flex && `flex: ${p.flex}`}
  background: #F9F9F9;
  border: 1px solid #F1F1F1;
  border-radius: 4px;
  padding: 8px 12px;
`

const FlexEndCol = styled(Col)`
  align-items: ${p => (p.center ? 'center' : 'flex-end')};
  ${p => p.flex && `flex: ${p.flex}`}
  padding: 8px 12px;
`

const Title = styled.span`
  font-family: ${FONTS.GOTHAM};
  font-size: ${FONTS.SMALL_SIZE};
  color: #808080;
`

const AlignCenterWrapper = styled(Row)`
  height: 100%;
  align-items: center;
`

const Text = styled.span`
  font-family: ${FONTS.NOTOSANS};
  font-size: ${FONTS.NORMAL_SIZE};
  color: #1A1A17;
`

const Number = styled(Text)`
  font-family: ${FONTS.NOTOSANS_MEDIUM};
  color: ${p => (p.color || '#1A1A17')};
`



// WEBPACK FOOTER //
// ./src/components/accounting-dashboard/data-table/ap-paying/edit-ap-paying/payout-detail/index.js